import ingredient from './modules/ingredient'
import language from './modules/language'
import dashBoard from './modules/dashBoard'
import navigationDrawer from './modules/NavigationDrawer'
import statement from './modules/statement'
import queuePage from './modules/queuePage'
import appointment from './modules/appointmentSchedule'
import patient from './modules/patient'
import opdreport from './modules/OpdReport'
import drugFormula from './modules/drugFormula'
import product from './modules/product'
import stock from './modules/stock'
import pos from './modules/pos'
import course from './modules/course'
import doctorModel from './modules/doctor'
import service from './modules/service'
import room from './modules/room'
import auth from './modules/auth'

export default {
  ingredient,
  language,
  dashBoard,
  navigationDrawer,
  statement,
  queuePage,
  appointment,
  patient,
  opdreport,
  drugFormula,
  product,
  stock,
  course,
  pos,
  doctorModel,
  service,
  room,
  auth,
  doctor: 'แพทย์',
  assistantDoctor: 'ผู้ช่วยแพทย์',
  TreatingDoctor: 'แพทย์ผู้รักษา',
  examiningDoctor: 'แพทย์ผู้ลงตรวจ',
  name: 'ชื่อ',
  lastname: 'นามสกุล',
  nameLastName: 'ชื่อ-นามสกุล',
  print: 'พิมพ์',
  img: 'รูป',
  phone: 'มือถือ',
  call: 'โทร',
  tel: 'เบอร์โทรศัพท์',
  signature: 'ลายเซ็น',
  signatory: 'ลงนาม',
  gender: 'เพศ',
  male: 'ชาย',
  female: 'หญิง',
  email: 'อีเมล',
  doctorName: 'ชื่อแพทย์',
  patientName: 'ชื่อคนไข้',
  inPatient: 'คนไข้ในระบบ',
  outPatient: 'คนไข้นอกระบบ',
  confirmDeletePatient: 'ยืนยันการลบคนไข้',
  confirmPatientDeletionPrompt: 'คุณกำลังลบคนไข้ ต้องการดำเนินการต่อหรือไม่',
  customer: 'ลูกค้า',
  searchDoctor: 'ค้นหาชื่อแพทย์',
  searchPatientName: 'ค้นหาชื่อคนไข้ในระบบ',
  selectDoctor: 'เลือกแพทย์',
  selectedBed: 'เลือกเตียง',
  selectAssistant: 'เลือกแพทย์ผู้ช่วย',
  selectedClinic: 'เลือกคลินิกของคุณ',
  selectTreatingDoctor: 'เลือกแพทย์ผู้รักษา',
  plzEnterData: 'โปรดกรอกข้อมูล',
  plzSelectData: 'โปรดเลือกข้อมูล',
  plzSelectDate: 'โปรดเลือกวันที่',
  status: 'สถานะ',
  selectStatus: 'เลือกสถานะ',
  type: 'ประเภท',
  selectType: 'เลือกประเภท',
  selectedPurchaseOrderType: 'เลือกประเภทใบสั่งซื้อ',
  selectDate: 'เลือกวันที่',
  examinationDate: 'วันที่ตรวจ',
  age: 'อายุ',
  create: 'สร้างข้อมูล',
  create0: 'สร้าง',
  edit: 'แก้ไขข้อมูล',
  delete: 'ลบข้อมูล',
  setting: 'ตั้งค่า',
  editAccount: 'แก้ไขบัญชี',
  editProductUnit: 'แก้ไขข้อมูลหน่วยสินค้า',
  save: 'บันทึก',
  recorder: 'ผู้บันทึก',
  ok: 'ตกลง',
  completed: 'เสร็จสิ้น',
  confirm: 'ยืนยัน',
  cancel: 'ยกเลิก',
  back: 'ย้อนกลับ',
  backToHome: 'กลับสู่หน้าหลัก',
  symptom: 'อาการ',
  logout: 'ออกจากระบบ',
  searchPatientOPDList: 'ค้นหาคนไข้, รายการ OPD',
  price: 'ราคา',
  salePrice: 'ราคาขาย',
  bath: 'บาท',
  total: 'ยอดรวม',
  cashPortion: 'ส่วนลด',
  placeholder: {
    enterName: 'กรอกชื่อ',
    enterNameEN: 'กรอกชื่อภาษาอังกฤษ',
    enterLastName: 'กรอกนามสกุล',
    enterLastNameEN: 'กรอกนามสกุลภาษาอังกฤษ',
    selectCustomer: 'เลือกลูกค้า',
    selectPatient: 'เลือกคนไข้',
    enterTel: 'กรอกเบอร์โทรศัพท์',
    searchPatientIdName: 'ค้นหารหัสคนไข้, ชื่อคนไข้',
    selectPrefix: 'เลือกคำนำหน้า',
    gender: 'เลือกเพศ',
    selectVerifyDay: 'เลือกวันลงตรวจ',
    examinationLocation: 'สถานที่ตรวจ',
    prefixEn: 'เลือกคำนำหน้าภาษาอังกฤษ',
    addressDetail: 'กรอกรายละเอียดที่อยู่',
    detailsAreAsFollows: 'มีรายละเอียดดังนี้',
    subdistrict: 'กรอกตำบล/แขวง',
    district: 'กรอกอำเภอ/เขต',
    province: 'กรอกจังหวัด',
    postCode: 'กรอกรหัสไปรษณีย์',
    country: 'เลือกประเทศ',
    plzEnterCorrectEmail: 'กรุณากรอกอีเมลให้ถูกต้อง',
    registrationEmail: 'กรุณากรอกอีเมล์ที่คุณใช้สมัคร',
    addPrefix: 'เพิ่มคำนำหน้าชื่อ',
    addPrefixEn: 'เพิ่มคำนำหน้าชื่อ(EN)',
    addGender: 'เพิ่มเพศ',
    addBloodType: 'เพิ่มกรุ๊ปเลือด',
    addPatientType: 'เพิ่มประเภทคนไข้',
    addChannelsToKnow: 'เพิ่มช่องทางที่รู้จักคลีนิค'

  },
  label: {
    time: 'เวลา',
    seconds: 'วินาที',
    hour: 'ชั่วโมง',
    timeStop: 'หยุดเวลา',
    day: 'วัน',
    to: 'ถึง',
    countdown: 'นับถอยหลัง',
    wait: 'รอ',
    week: 'สัปดาห์',
    month: 'เดือน',
    year: 'ปี',
    toDay: 'วันนี้',
    DMY: 'วันเดือนปี',
    stop: 'หยุด',
    start: 'เริ่ม',
    formDay: 'จากวันที่',
    verifyDay: 'วันที่ลงตรวจ',
    treatmentDate: 'วันที่รักษา',
    createDocDate: 'วันที่ออกเอกสาร',
    issuedDate: 'ออกให้เมื่อวันที่',
    andOnDate: 'แล้วเมื่อวันที่',
    examinationStartTime: 'เวลาเริ่มลงตรวจ',
    examinationEndTime: 'เวลาเลิกลงตรวจ',
    prefix: 'คำนำหน้า',
    prefixEn: 'คำนำหน้า (EN)',
    TimeToCreateExamination: 'เวลาที่เคยสร้างการลงตรวจ',
    duty: 'เวรตรวจของ',
    emContact: 'ติดต่อกรณีฉุกเฉิน',
    search: 'ค้นหา',
    add: 'เพิ่ม'
  },
  toolTip: {
    queuePage: 'หน้าคิว',
    addPatient: 'เพิ่มข้อมูลคนไข้',
    appointmentTable: 'ตารางนัดหมายคนไข้',
    nextAppointment: 'นัดครั้งถัดไป',
    createUser: 'สร้างผู้ใช้งาน',
    addProductAndFormula: 'เพิ่มข้อมูลสินค้าและยา'
  },
  address: {
    address: 'ที่อยู่',
    contactAddress: 'ที่อยู่ (ที่ติดต่อได้)',
    addressDetail: 'รายละเอียดที่อยู่',
    subdistrict: 'ตำบล/แขวง',
    district: 'อำเภอ/เขต',
    province: 'จังหวัด',
    postCode: 'รหัสไปรษณีย์',
    citizenId: 'เลขที่บัตรประชาชน',
    country: 'ประเทศ'
  },
  shortAddress: {
    s: 'ต.',
    d: 'อ.',
    p: 'จ.'
  },
  prefix: {
    mr: 'นาย',
    iAm: 'ข้าพเจ้า',
    mrs: 'นาง',
    miss: 'นางสาว',
    dr_male: 'นพ.',
    dr_female: 'พญ.',
    mr_mrs_miss: '(นาย, นาง, นางสาว)'

  },
  alert: {
    noDataSearch: 'ไม่พบข้อมูลที่ค้นหา'
  },
  modal: {
    create: {
      success: 'สร้างข้อมูลสำเร็จ !'
    },
    edit: {
      success: 'แก้ไขข้อมูลสำเร็จ !'
    },
    delete: {
      success: 'ลบข้อมูลสำเร็จ !',
      subTitle: 'คุณกำลังจะลบข้อมูล คุณต้องการดำเนินการต่อหรือไม่?'
    }
  }
}
